import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { ErrorBoundary } from 'bernie-view';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { VoiceOfTheCustomer } from '@shared-ui/customer-voice-of-the-customer';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { LocalizedText } from '@shared-ui/localization-context';
import { IncentivesCollectionCarouselWrapper } from 'components/search/shared-ui/shared-ui-incentives-collection-carousel';
import { RecommendationsCarouselWrapper } from 'components/search/shared-ui/shared-ui-recommendations-carousel';
import { MesoFooter } from '../../meso/meso-footer';
import { PackageProductCard } from '../package-product-card/package-product-card';
import { PropertySearchListings } from '../property-search-listings/property-search-listings';
export const Results = inject('searchResults')(observer(({
  searchResults,
  errorMessage,
  similarDestinationProps
}) => {
  var _a, _b, _c;
  const a11yHeaders = ((_a = searchResults === null || searchResults === void 0 ? void 0 : searchResults.resultsHeading) !== null && _a !== void 0 ? _a : '').split('|');
  const a11yPrimaryHeader = (_b = a11yHeaders[0]) !== null && _b !== void 0 ? _b : '';
  const a11ySecondaryHeader = (_c = a11yHeaders[1]) !== null && _c !== void 0 ? _c : '';
  // Moves the focus back to Map
  const onHandleKeyDown = event => {
    if (event.shiftKey && event.key === 'Tab') {
      const mapFocusDummyElement = document.getElementById('map-focus-holder-exit');
      if (mapFocusDummyElement) {
        mapFocusDummyElement.focus();
      }
    }
  };
  return React.createElement(React.Fragment, null, a11yPrimaryHeader && React.createElement("h1", {
    className: "is-visually-hidden"
  }, a11yPrimaryHeader), React.createElement(PackageProductCard, null), !(searchResults === null || searchResults === void 0 ? void 0 : searchResults.header) && React.createElement("h2", {
    className: "is-visually-hidden"
  }, a11ySecondaryHeader || React.createElement(LocalizedText, {
    message: "hotels.search.results.heading"
  })), React.createElement(PropertySearchListings, null), React.createElement("div", {
    id: "post-map-focus-footer",
    role: "button",
    onKeyDown: onHandleKeyDown,
    tabIndex: 0,
    "aria-label": "Footer"
  }), errorMessage, React.createElement(Experiment, {
    name: "SRP_Alternative_destinations_recs"
  }, React.createElement(ExperimentControl, null, React.createElement(RecommendationsCarouselWrapper, null)), React.createElement(ExperimentVariant, {
    bucket: 1
  }, similarDestinationProps && React.createElement(IncentivesCollectionCarouselWrapper, Object.assign({}, similarDestinationProps)))), React.createElement(MesoFooter, null), React.createElement(ErrorBoundary, {
    label: "voice-of-the-customer"
  }, React.createElement(EGDSSpacing, {
    margin: {
      medium: {
        blockstart: 'six'
      }
    }
  }, React.createElement("div", {
    "data-stid": "shared-ui-voice-of-the-customer"
  }, React.createElement(VoiceOfTheCustomer, {
    inputs: {}
  })))));
}));